// AUTO GENERATED FILE BY @kalissaac/prisma-typegen
// DO NOT EDIT

export enum PaymentStatus {
  free = "free",
  pending = "pending",
  cash_success = "cash_success",
  gateway_success = "gateway_success",
  gateway_expired = "gateway_expired",
  gateway_failed = "gateway_failed",
  gateway_unknown = "gateway_unknown",
  partially_paid_at_door = "partially_paid_at_door",
}

export enum ReservationStatus {
  pending = "pending",
  accepted = "accepted",
  rejected = "rejected",
  cancelled = "cancelled",
  invited = "invited",
}

export enum CompaignStatus {
  draft = "draft",
  processing = "processing",
  approved = "approved",
  sent = "sent",
}

export enum NotificationStatus {
  pending = "pending",
  approved = "approved",
  processed = "processed",
}

export enum AttendanceLogType {
  checkin = "checkin",
  checkout = "checkout",
  invitation = "invitation",
  invitation_accepted = "invitation_accepted",
  reservation_accepted = "reservation_accepted",
  reservation_rejected = "reservation_rejected",
  payment = "payment",
}

export enum PaymentSource {
  DASHBOARD = "DASHBOARD",
  GATEWAY = "GATEWAY",
  TERMINAL = "TERMINAL",
}

export enum PosProductStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

export enum PosOrderPaymentStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  REFUNDED = "REFUNDED",
  CANCELLED = "CANCELLED",
}

export enum PosOrderFulfillmentStatus {
  CREATED = "CREATED",
  READY = "READY",
  CANCELLED = "CANCELLED",
}

export enum OperationType {
  ACTIVATION = "ACTIVATION",
  TICKET_PREFILL = "TICKET_PREFILL",
  PAYMENT_CASH = "PAYMENT_CASH",
  PAYMENT_TPE = "PAYMENT_TPE",
  PAYMENT_CASHLESS = "PAYMENT_CASHLESS",
  PAYMENT_GATEWAY_INTENT = "PAYMENT_GATEWAY_INTENT",
  PAYMENT_GATEWAY_SUCCESS = "PAYMENT_GATEWAY_SUCCESS",
  PAYMENT_GATEWAY_ERROR = "PAYMENT_GATEWAY_ERROR",
  REFUND = "REFUND",
  PROVISION_TPE = "PROVISION_TPE",
  PROVISION_CASH = "PROVISION_CASH",
  PROVISION_GATEWAY_INTENT = "PROVISION_GATEWAY_INTENT",
  PROVISION_GATEWAY_SUCCESS = "PROVISION_GATEWAY_SUCCESS",
  PROVISION_GATEWAY_ERROR = "PROVISION_GATEWAY_ERROR",
  TRANSFER = "TRANSFER",
  COMMISSION = "COMMISSION",
  COLLECT_CASH = "COLLECT_CASH",
  COLLECT_TPE = "COLLECT_TPE",
  PAYOUT_CASH = "PAYOUT_CASH",
  PAYOUT_TPE = "PAYOUT_TPE",
}

export enum TransactionStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
}

export interface User {
  id: number;
  username: string;
  email: string;
  organization?: Organization;
  organizationId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Organization {
  id: number;
  name: string;
  description?: string;
  additionalInformation?: any;
  categories?: any;
  paymentFeesPaidByClient?: boolean;
  image?: any;
  subdomain?: string;
  defaultTheme?: string;
  additionalCss?: string;
  users: User[];
  events: Event[];
  tickets: Ticket[];
  discussions: Discussion[];
  notifications: Notification[];
  invoices: Invoice[];
  published?: boolean;
  umamiSettings?: any;
  konnectSettings?: any;
  targetSettings?: any;
  stripeSettings?: any;
  chatwootSettings?: any;
  approved: boolean;
  cashlessCommission?: number;
  legalDocuments?: any;
  flags?: any;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  Projection: Projection[];
}

export interface Event {
  id: number;
  name?: string;
  description?: string;
  startDate?: Date;
  endDate?: Date;
  venue?: any;
  hiddenVenue?: boolean;
  hiddenDates?: boolean;
  hasProjections?: boolean;
  tickets: Ticket[];
  attendees: Attendee[];
  compaigns: Compaign[];
  orders: Order[];
  discussions: Discussion[];
  terminals: Terminal[];
  posProducts: PosProduct[];
  posOrders: PosOrder[];
  walletTransactions: WalletTransaction[];
  projections: Projection[];
  organization: Organization;
  organizationId: number;
  publishable?: boolean;
  published?: boolean;
  hidden?: boolean;
  image?: any;
  subdomain?: string;
  customApp?: any;
  cashAccepted?: boolean;
  cardAccepted?: boolean;
  cashlessEnabled?: boolean;
  approvalRequired?: boolean;
  preApprovalStage?: boolean;
  helperMessages?: any;
  passportAppFeatures?: any;
  paymentRate?: number;
  notificationPreferences?: any;
  theme?: any;
  additionalCss?: string;
  targetListReference?: string;
  seatSettings?: any;
  minimumTopUpAmount?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Projection {
  id: number;
  date: Date;
  tags?: any;
  event: Event;
  eventId: number;
  organization: Organization;
  organizationId: number;
  attendees: Attendee[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface PublicEvent {
  id: number;
  name?: string;
  description?: string;
  startDate?: Date;
  endDate?: Date;
  venue?: any;
  prices?: any;
  link?: string;
  image?: any;
  published?: boolean;
  hash?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Subscription {
  id: number;
  email: string;
  entityType: string;
  entityId?: string;
  enabled: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Ticket {
  id: number;
  name: string;
  price: number;
  description: string;
  quantity: number;
  minPerOrder?: number;
  maxPerOrder?: number;
  quantityStepPerOrder?: number;
  maxCheckins: number;
  isHidden?: boolean;
  accessCodes?: any;
  questions?: any;
  isDisabled?: boolean;
  isOnlyForCommunity?: boolean;
  cashlessPrefill?: number;
  image?: any;
  event: Event;
  eventId: number;
  organization: Organization;
  organizationId: number;
  parentTicket?: Ticket;
  parentTicketId?: number;
  childTickets: Ticket[];
  attendees: Attendee[];
  additionalEvents?: any;
  category?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Attendee {
  id: number;
  reference: string;
  name: string;
  email: string;
  phone: string;
  sex?: string;
  avatar?: any;
  answers?: any;
  attendanceLog?: any;
  balance?: number;
  qrPaymentTokenInfo?: any;
  qrPhysicalWallet?: string;
  nfcPhysicalWallet?: string;
  isPendingProfileUpdate: boolean;
  loginTokenUsed: boolean;
  isOneTimeLogin: boolean;
  loginTokenVersion: number;
  comments?: any;
  tags?: any;
  event: Event;
  eventId: number;
  ticket: Ticket;
  ticketId: number;
  order: Order;
  orderId: number;
  projection?: Projection;
  projectionId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Order {
  id: number;
  reference: string;
  name: string;
  email: string;
  phone: string;
  paymentRef?: string;
  paymentStatus: PaymentStatus;
  reservationStatus: ReservationStatus;
  totalAmount: number;
  paidAmount: number;
  attendeesPaidAtDoor?: any;
  createdBy?: any;
  paidBy?: any;
  comments?: any;
  tags?: any;
  referralReference?: string;
  selectedSeats?: any;
  attendees: Attendee[];
  event: Event;
  eventId: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Job {
  id: number;
  type: string;
  payload: any;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface Compaign {
  id: number;
  name: string;
  recipients?: any;
  replyto?: string;
  payload?: any;
  design?: any;
  status: CompaignStatus;
  event: Event;
  eventId: number;
  sentAt?: Date;
  statsMessageKey?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface Discussion {
  id: number;
  organizationId?: number;
  organization?: Organization;
  eventId?: number;
  event?: Event;
  discussionHash: string;
  userInfos?: any;
  subjects?: any;
  messages?: any;
  readAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface NameGender {
  id: number;
  name?: string;
  gender?: string;
  probability?: string;
}

export interface Terminal {
  id: number;
  name: string;
  phone: string;
  permissions?: any;
  isDisabled?: boolean;
  health?: any;
  event: Event;
  eventId: number;
  posCategories?: any;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface Notification {
  id: number;
  payload: any;
  destination: any;
  status: string;
  organization: Organization;
  organizationId: number;
  createdAt: Date;
  processedAt?: Date;
  deletedAt?: Date;
}

export interface PosProduct {
  id: number;
  name: string;
  price: number;
  description?: string;
  image?: any;
  status: PosProductStatus;
  maxQuantityPerOrder?: number;
  publiclyAvailable?: boolean;
  posCategory: string;
  event?: Event;
  eventId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export interface PosOrder {
  id: number;
  reference?: string;
  createdBy: any;
  cartContent?: any;
  totalAmount: number;
  paidAmount: number;
  paymentStatus?: PosOrderPaymentStatus;
  fulfillmentStatus?: PosOrderFulfillmentStatus;
  comments?: any;
  statusHistory?: any;
  channel?: string;
  deliveryLocation?: string;
  event: Event;
  eventId: number;
  walletTransactions: WalletTransaction[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface WalletTransaction {
  id: number;
  operationType: OperationType;
  sender: any;
  receiver: any;
  paymentRef?: string;
  amount?: number;
  additionalInformation?: any;
  event: Event;
  eventId: number;
  posOrder?: PosOrder;
  posOrderId?: number;
  status: TransactionStatus;
  comments?: any;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface Invoice {
  id: number;
  reference: string;
  issueDate: Date;
  dueDate: Date;
  billingStart: Date;
  billingEnd: Date;
  client: any;
  items: any;
  status: string;
  type: string;
  total: number;
  subTotal: number;
  taxAmount: number;
  organizationId: number;
  organization: Organization;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}
